module.exports = __webpack_public_path__ + "img/s00155.976707f0.jpg";